__turbopack_context__.v({
  "className": "avenirnextmedium_f9414ef0-module__KHzcfG__className",
  "variable": "avenirnextmedium_f9414ef0-module__KHzcfG__variable",
});
